"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ShareLocationHand: ['share-location-hand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.714,16.5a1.058,1.058,0,0,0,.8-.369c.213-.251,5.234-6.177,5.234-10.1a6.036,6.036,0,1,0-12.071,0c0,3.921,5.02,9.844,5.234,10.094A1.053,1.053,0,0,0,16.714,16.5ZM14.5,6.036A2.215,2.215,0,1,1,16.714,8.25,2.215,2.215,0,0,1,14.5,6.036Z', 'M16.75,19.5H7.625a.625.625,0,0,1,0-1.25H10.15a1,1,0,0,0,.92-1.394A2.235,2.235,0,0,0,9.014,15.5H4.75a.5.5,0,0,0-.5.5v6.5a.5.5,0,0,0,.5.5H15.514a2.238,2.238,0,0,0,2.236-2.236V20.5A1,1,0,0,0,16.75,19.5Z', 'M2.25,14.75a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V15.75A1,1,0,0,0,2.25,14.75Z']],
  ShareLocationHand2: ['share-location-hand-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16,17a1,1,0,0,0,.762-.352C17.349,15.958,22.5,9.81,22.5,6.5a6.5,6.5,0,0,0-13,0c0,3.31,5.151,9.458,5.738,10.148A1,1,0,0,0,16,17ZM16,4.5a2,2,0,1,1-2,2A2,2,0,0,1,16,4.5Z', 'M17,19.5H7.875a.625.625,0,0,1,0-1.25H10.4a1,1,0,0,0,.919-1.394A2.234,2.234,0,0,0,9.264,15.5H5a.5.5,0,0,0-.5.5v6.5A.5.5,0,0,0,5,23H15.764A2.238,2.238,0,0,0,18,20.764V20.5A1,1,0,0,0,17,19.5Z', 'M2.5,14.75a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V15.75A1,1,0,0,0,2.5,14.75Z']]
};
exports["default"] = _default;